<template>
  <Layout>
    <Content :style="{'padding': '10px'}">
      <Card :style="{'padding':'0px 5px','margin-bottom':'5px'}">
		  <span class="search_span_width">
		  	<span class="search_span_width_part1">ID：</span>
		  	<Input v-model="search.id" clearable style="width: 80px" />
		  </span>
            <span class="search_span_width">
                <span class="search_span_width_part1">语种：</span>
				 <Select v-model="search.lang" style="width:130px" clearable>
				        <Option v-for="item in lang_list" :value="item.key" :key="item.key">{{ item.name }}</Option>
				</Select>
            </span>
			<span class="search_span_width">
			    <span class="search_span_width_part1">分组：</span>
				 <Select v-model="search.group_id" style="width:130px" clearable>
				        <Option :value="1" :key="1">默认</Option>
						<Option :value="2" :key="2">智慧零售</Option>
				</Select>
			</span>
			<span class="search_span_width">
			  <span class="search_span_width_part1">&nbsp;&nbsp;渠道：</span>
			  <Select v-model="search.channel" clearable style="width:130px">
			    <Option v-for="(item,index) in channel_list" :value="item.id" :key="index">{{ item.name }}</Option>
			  </Select>
			</span>
			<span class="search_span_width">
				<span class="search_span_width_part1">标签：</span>
				<Select v-model="search.tag_id" style="width:130px" clearable>
					<Option v-for="item in tag_list" :value="item.id" :key="item.id">{{ item.name }}</Option>
				</Select>
			</span>
			<span class="search_span_width">
				<span class="search_span_width_part1">服务商：</span>
				<Select v-model="search.server" style="width:130px" clearable>
					<Option v-for="(item,index) in server_list" :value="index" :key="index">{{ item }}</Option>
				</Select>
			</span>
			<br/><br/>
			<span class="search_span_width">
				<span class="search_span_width_part1">客户：</span>
				<Select style="width:150px"
					 v-model="search.user_id"
					 filterable
                clearable
					 :remote-method="userlist"
					 :loading="loading2">
					 <Option v-for="(option, index) in user_list" :value="option.id" :key="index">{{option.mobile}}</Option>
				</Select>
			</span>
        <span class="search_span_width">
			<span class="search_span_width_part1">描述：</span>
			<Input v-model="search.intro" clearable style="width: 130px" />
        </span>
			<!-- <span  class="search_span_width">
			    &nbsp;&nbsp;&nbsp;&nbsp;<Checkbox label="1" v-model="search.share">独享</Checkbox>
			</span> -->
        <span class="search_span_width">
          <span class="search_span_width_part1">音色有效期：</span>
          <Select style="width:150px"  v-model="search.timbre_status">
             <Option :value="0" >全部</Option>
             <Option :value="1" >未过期</Option>
             <Option :value="2" >已过期</Option>
             <Option :value="3" >即将过期(1个月)</Option>
          </Select>
        </span>
        <Button type='primary' icon="ios-search" :style="{'margin-left':'20px'}" @click="getSpeakerList(1)">搜索</Button>
		<Button type='success' :style="{'margin-left':'25px'}" @click="addSpeakerModal()">添加声音</Button>
		
      </Card>
      <Card>
        <Card id="tableContent" >
          <Table :columns="tableColumns" :data="speaker_list"  :row-class-name="getRowClassName"></Table>
		  <Page :total="recordTotal" :current="page" :page-size="20" :show-elevator="true" @on-change="getSpeakerList"/>
        </Card>
      </Card>
    </Content>
   <Modal v-model="showmodal" :footer-hide=true title="声音" >
        <Form ref="speaker" :model="speaker" :label-width="80" :rules="userRule" >
			<FormItem label="语言" prop="lang">
			<Select v-model="speaker.lang" style="width:200px">
			       <Option v-for="item in lang_list" :value="item.key" :key="item.key">{{ item.name }}</Option>
			   </Select>
			</FormItem>
			<FormItem label="声音分组" prop="group_id">
			  <RadioGroup v-model="speaker.group_id">
			    <Radio label="1">默认</Radio>
				<Radio label="2">智慧零售</Radio>
			  </RadioGroup>
			</FormItem>
			<FormItem label="渠道" prop="channel">
				<Select v-model="speaker.channel" clearable style="width:150px">
				  <Option v-for="(item,index) in channel_list" :value="item.id" :key="index">{{ item.name }}</Option>
				</Select>
			</FormItem>
      <FormItem label="所属客户">
        <span  v-if="belong_cust">
         <Tag size="large" closable @on-close="clearBelongCust">{{belong_cust}}</Tag>
        </span>
        <Select
            v-else
            filterable
            v-model="speaker.user_id"
            :remote-method="userlist"
            :loading="loading2">
          <Option  v-for="(option, index) in user_list" :value="option.id" :key="index">{{option.mobile ? option.mobile : option.email}}</Option>
        </Select>
      </FormItem>
      <FormItem label="上架客户">
        <Row style="width:500px">
          <Col span="11" style="width:200px">
            <FormItem style="width:200px">
              <Select
                filterable
                v-model="option_user_id"
                :remote-method="userlist"
                :loading="loading2">
              <Option  v-for="(option, index) in user_list" :value="option.id" :key="index">{{option.mobile ? option.mobile : option.email}}</Option>
            </Select>
            </FormItem>
          </Col>
          <Col span="11">
            <FormItem prop="time">
              <Button type="primary" @click="addOptionUser()">添加</Button>
            </FormItem>
          </Col>
        </Row>
        <span v-for="(item, index) in option_user_list">
         <Tag size="large" closable @on-close="handleClose(item.id)">{{item.mobile ? item.mobile : item.email}}</Tag>
        </span>
    </FormItem>
			<FormItem label="性别" prop="sex">
				<RadioGroup v-model="speaker.sex">
				        <Radio label="男"></Radio>
				        <Radio label="女"></Radio>
				</RadioGroup>
			</FormItem>
			<FormItem label="名称" prop="intro">
			    <Input v-model="speaker.intro"  />
			</FormItem>
          <FormItem label="英文名称" prop="en_intro">
            <Input v-model="speaker.en_intro"  />
          </FormItem>
			<FormItem label="服务商" prop="server">
				<Select v-model="speaker.server" style="width:260px">
					<Option v-for="(item,index) in server_list" :value="index" :key="index">{{ item }}</Option>
				</Select>
			</FormItem>
			<FormItem label="服务商名称" prop="plt_name">
			    <Input v-model="speaker.plt_name"  />
			</FormItem>
			<FormItem label="标签" prop="tag_id">
				<Select v-model="speaker.tag_id" multiple style="width:260px">
					<Option v-for="item in tag_list" :value="item.id" :key="item.id">{{ item.name }}</Option>
				</Select>
			</FormItem>
			<FormItem label="人物id" >
				<Input v-model="figureSearch.figure_id"  style="width:260px"/>
				<Button type='primary' icon="ios-search" :style="{'margin-left':'20px'}" @click="searchInfo()">查询</Button>
			</FormItem>
			<FormItem label="标识" prop="plt_spk" >
			    <Input v-model="speaker.plt_spk"  />
			</FormItem>

      <FormItem label="音色" prop="timbre" >
          <Input v-model="speaker.timbre"  />
        <span style="color: red"> *标识/音色 必须填写一个</span>
      </FormItem>
			<FormItem label="排序" prop="seq">
			    <Input v-model="speaker.seq"  />
			</FormItem>

            <FormItem>
                <Button type="primary" @click="updateSpeaker()">提交</Button>
            </FormItem>
        </Form>
    </Modal>
   <Modal v-model="showRecharge" :footer-hide=true title="音色续费" >
      <Form  :model="rechargeForm" :label-width="80" >
        <FormItem label="音色ID">
          <Input v-model="rechargeForm.voice_id"  :disabled=true />
        </FormItem>
        <FormItem label="充值时长">
          <InputNumber  :precision="0" :min="0" :max="12" v-model="rechargeForm.recharge_month" />
        </FormItem>
        <FormItem>
          <Button type="primary" @click="rechargeVoice()">提交</Button>
        </FormItem>
      </Form>
  </Modal>
  </Layout>
</template>
<script>
export default {
  data(){
    return {
		search : {
			lang:'',
			tag_id:0,
			user_id:0,
			share:0,
			server:'',
			group_id: '',
			intro:'',
      timbre_status:0
		},
		option_user_id:0,
		figureSearch:{
			figure_id:0
		},
		voiceSearch:{
			figure_id:0
		},
		page: 1,
		loading2: false,
		recordTotal:0,
		showmodal:false,
    showRecharge:false,
		speaker_list:[],
		lang_list:[],
		tag_list:[],
		user_list:[],
		channel_list:[],
        option_user_list:[],
		server_list:[],
		speaker:{
			id:0,
			intro:'',
			en_intro:'',
			lang:'zh',
			seq:0,
			sex:'男',
			tag_id:[],
			server:'',
			plt_name:'',
			plt_spk:'',
			timbre:'',
			user_id:0,
			group_id : '1',
			user_ids:[],
			channel:'all'
		},
    rechargeForm:{
      "voice_name":"",
      "voice_id":0,
      "recharge_month":0
    },
    belong_cust:"",
		userRule :{
				server:[{ required: true, message: "请选择服务商", trigger: "change" }],
				intro: [{ required: true, message: '介绍不能为空', trigger: 'blur' }],
				//plt_spk: [{ required: true, message: '请输入标识', trigger: 'blur' }]
		},
		tableColumns:[
		{ title: 'ID', key: 'id', align: 'center',width:'80px' },
		{ title: '所属用户', key: 'user_id', align: 'center',width:'80px'},
		 { title: '上架用户', key: 'user_id', align: 'center',width:'80px', render:(h,params) =>{
		 	 let status = '共享';
		     if (params.row.user_ids.length > 0) {
		 		status = params.row.user_ids.join();
		 	}
		 	return h('span',{},status);
		  }},
		 { title: '渠道', key: 'channel', align: 'center',width:'80px' },
		{ title: '服务', key: 'server_name', align: 'center',width:'80px' },
		{ title: '性别', key: 'sex', align: 'center',width:'80px' },
		{ title: '描述', key: 'intro', align: 'center',width:'100px' },
		{ title: '标签', key: 'tag_name',width:'100px', align: 'center' },
		{ title: '试听', key: 'voice',width:'140px',
			render:(h,params) =>{
			   return h('span',{
				 domProps: {
				    innerHTML: '<audio controls="controls" style="width:100px;height:25px;"><source src="'+params.row.voice+'" type="audio/mpeg" /></audio>'
				}
			   })
			}
		 },
		{ title: '有效期', key: 'start_time', align: 'center', width:'200px', render:(h,params) =>{
		 	return h('span',{},params.row.start_time ? params.row.start_time+' /'+params.row.end_time : '');
		  }},
    { title: '音色有效期', key: 'start_time', align: 'center', width:'200px', render:(h,params) =>{
          return h('span',{},params.row.voice_train_speaker_start_time ? params.row.voice_train_speaker_start_time+' /'+params.row.voice_train_speaker_expire_time : '');
    }},
		{ title: '排序', key: 'seq', align: 'center',width:'80px' },
		{ title: '操作', key: 'action', fixed:'right', width:'200px', align: 'center',
		  render: (h, params) => {
			let btns=[]
      if(params.row.expire_status==3||params.row.expire_status==1){
          btns.push(
              h('Button', {
                props: { type: 'success', size: 'small' },
                style: { marginRight: '5px', marginBottom: '5px'},
                on: {
                  click: () => {
                    this.showRecharge = true;
                    this.getVoiceDetail(params.row.timbre)
                  }
                }
              }, '音色续费'),
          );
      }
      btns.push(
				h('Button', {
				  props: { type: 'warning', size: 'small' },
				  style: { marginRight: '5px', marginBottom: '5px'},
				  on: {
					click: () => {
						this.figureSearch.figure_id=0;
						this.speaker.id = params.row.id;
						this.speaker.intro = params.row.intro;
						this.speaker.lang = params.row.lang;
						this.speaker.en_intro = params.row.en_intro;
						this.speaker.seq = params.row.seq;
						this.speaker.tag_id = params.row.tag_id;
						this.speaker.server = params.row.server;
						this.speaker.plt_name = params.row.plt_name;
						this.speaker.plt_spk = params.row.plt_spk;
						this.speaker.lang = params.row.lang;
						this.speaker.timbre = params.row.timbre;
						this.speaker.sex = params.row.sex;
						this.speaker.user_id = params.row.user_id;
						this.speaker.user_ids = params.row.user_ids;
						this.speaker.group_id = params.row.group_id;
						this.speaker.channel = params.row.channel;
						this.option_user_list = [];
            this.belong_cust = ""
						if(this.speaker.user_ids.length>0){
							this.getOptionUserList(this.speaker.user_ids);
						}
            if(this.speaker.user_id){
              this.getUserInfoById(this.speaker.user_id)
            }
						this.showmodal = true;
					}
				  }
				}, '编辑'),
			);
      btns.push(
          h('Button', {
            props: { type: 'success', size: 'small' },
            style: { marginRight: '5px', marginBottom: '5px'},
            on: {
              click: () => {
                this.updateShowStatus(params.row)
              }
            }
          }, params.row.hide==1?'显示':'隐藏'),
      );

			return h("div",btns);
		  }
		}
		]
	}
  },
  mounted:function(){
	this.getTagList();
	this.getLangList();
    this.getSpeakerList(1);
	this.getChannelList();
  },
  computed:{

  },
  methods:{
  addSpeakerModal(){
		this.speaker.id = 0;
		this.speaker.intro = '';
		this.speaker.en_intro = '';
		this.speaker.seq = 0;
		this.speaker.tag_id = [];
		this.speaker.server = '';
		this.speaker.plt_name = '';
		this.speaker.plt_spk = '';
		this.speaker.lang = 'zh';
		this.speaker.sex = '男';
		this.speaker.timbre = '';
		this.figureSearch.figure_id=0;
		this.speaker.user_id = 0;
		this.speaker.user_ids = [];
		this.speaker.group_id = '1';
		this.option_user_list = [];
		this.speaker.channel = 'all';
		this.showmodal = true;
  },
    handleClose(i) {
      this.option_user_list = this.option_user_list.filter(item => item.id != i);
      this.speaker.user_ids = this.speaker.user_ids.filter(item => item != i);
    },
    addOptionUser(){
      if(this.option_user_id){
        if(!this.speaker.user_ids.includes(this.option_user_id)){
          this.speaker.user_ids.push(this.option_user_id);
          this.getOptionUserList(this.speaker.user_ids);
        }
      }
      this.option_user_id = 0;
    },
	getChannelList(){
	  this.http.get('/admin/agent/channelList').then(response=>{
	    let data=response.data;
	    if(data.code!==0)
	    {
	      alert(data.message);
	    } else{
	      if (data.data) {
	        this.channel_list = data.data;
	      }
	    }
	  }).catch(()=>{
	    this.$Message.error('网络错误');
	  });
	},
    getOptionUserList(ids) {
      let params = {'ids':ids,'account_type':0}
      this.http.get('/admin/user/userList',{params:params}).then(response=>{
        let data=response.data;
        if(data.code!==0)
        {
          alert(data.message);
        } else{
          this.option_user_list = data.data.list;
        }
      }).catch(()=>{
        this.$Message.error('网络错误');
      });
    },
    getUserInfoById(id) {
      let params = {'id':id,'account_type':0}
      this.http.get('/admin/user/userList',{params:params}).then(response=>{
        let data=response.data;
        if(data.code!==0)
        {
          alert(data.message);
        } else{

          if(data.data && data.data.list &&data.data.list[0]){
             this.belong_cust = data.data.list[0].mobile? data.data.list[0].mobile: data.data.list[0].email;
          }


        }
      }).catch(()=>{
        this.$Message.error('网络错误');
      });
    },
    clearBelongCust(){
      this.belong_cust=""
      this.speaker.user_id=""
    },
	getTagList(page=this.page) {
		this.http.get('/admin/figure/speakerTags').then(response=>{
		  let data=response.data;
		  console.log(data);
		  if(data.code!==0){
			alert(data.message);
		  } else{
			this.tag_list = data.data;
		  }
		}).catch(()=>{
		  this.$Message.error('网络错误');
		});
	},
	getLangList() {
		this.http.get('/admin/figure/language').then(response=>{
		  let data=response.data;
		  if(data.code!==0){
			alert(data.message);
		  } else{
			this.lang_list = data.data;
		  }
		}).catch(()=>{
		  this.$Message.error('网络错误');
		});
	},
	getSpeakerList(page=this.page) {
		this.page = page;
		let p = {'page' : page}
		let params = Object.assign(this.search, p);
		this.http.get('/admin/figure/speakerList',{params:params}).then(response=>{
		  let data=response.data;
		  if(data.code!==0){
			alert(data.message);
		  } else{
			this.speaker_list = data.data.list;
			this.recordTotal = data.data.total;
			this.server_list= data.data.server;
		  }
		}).catch(()=>{
		  this.$Message.error('网络错误');
		});
	},
	updateSpeaker(){
		this.$refs["speaker"].validate((valid) => {
		  if (valid) {
        if(this.speaker.plt_spk ==="" &&this.speaker.timbre ==="")
        {
          this.$Message.error("标识/音色 不能同时为空");
          return false;
        }
			  this.$Spin.show();
			  this.http.post('/admin/figure/editSpeaker',this.speaker).then(response=>{
			    let data=response.data;
			    if(data.code!==0) {
			      this.$Message.error(data.message);
				  this.$Spin.hide();
			      return false;
			    } else{
			      this.$Message.info(data.message);
			      this.showmodal = false;
				  this.$Spin.hide();
			  	  this.getSpeakerList(this.page);
			      return true;
			    }
			  });

		  } else {
			this.$Message.error("表单验证未通过");
          }
		})

	},
	searchInfo() {
    if(this.figureSearch.figure_id<1){
      alert('人物id不能为空');
      return false;
    }
      this.http.get('/admin/figure/list',{params:this.figureSearch}).then(response=>{
        let data=response.data;

        if(data.code!==0){
          alert(data.message);
        } else{
			if(data.data.total<1){
				alert('人物数据不存在');
        this.speaker.plt_spk = '';
			}else{
				this.speaker.plt_spk =  data.data.list[0].scene_id;
			}
        }
      }).catch(()=>{
        this.$Message.error('网络错误');
      });
    this.http1.get('/voice/voice-list',{params:this.figureSearch}).then(response=>{
      let data=response.data;
      if(data.code!==0){
        alert(data.message);
      } else{
        if(data.res.total>0){
          this.speaker.timbre =  data.res.list[0].timbrekey;
        }else{
          this.speaker.timbre = '';
        }
      }
    }).catch(()=>{
      this.$Message.error('网络错误');
    });
    },
	userlist(query){
		if (query !== '') {
			this.loading2 = true;
			setTimeout(() => {
				this.loading2 = false;

				this.http.get('/admin/user/userList',{params:{mobile:query,account_type:0}}).then(response=>{
				  let data=response.data;
				  if(data.code!==0)
				  {
					alert(data.message);
				  } else{
					this.user_list = data.data.list;
				  }
				}).catch(()=>{
				  this.$Message.error('网络错误');
				});

			}, 200);
		}
	},
    closeModal(){
		this.speaker.id = 0;
		this.speaker.sex = 0;
		this.speaker.intro = '';
      this.speaker.en_intro = '';
		this.speaker.seq = 0;
		this.showmodal=false;
      this.figureSearch.figure_id=0;
    },
    rechargeVoice(){
      if(!this.rechargeForm.recharge_month){
        this.$Message.warning('充值时长不能为空');
        return false;
      }
      this.http.post('/admin/figure/rechargeVoice',this.rechargeForm).then(response=>{
        let data=response.data;
        if(data.code!==0){
          alert(data.message);
        } else{
          this.showRecharge = false;
          this.search={}
          this.getSpeakerList()
          this.$Message.success('充值成功');
        }
      }).catch(e=>{
        console.log(e)
        this.$Message.error('网络错误');
      });
    },
    getVoiceDetail(voiceId){
      this.http.get('/admin/figure/getVoiceDetail',{params:{"voice_id": voiceId}}).then(response=>{
        let data=response.data;
        console.log("response:", data)
        if(data.code!==0){
          alert(data.message);
        } else{
          this.rechargeForm.voice_name=data.data.voice_name
          this.rechargeForm.voice_id = data.data.model_id
        }
      }).catch(()=>{
        this.$Message.error('网络错误');
      });
    },
    getRowClassName(row) {
      return row.hide == 1 ? 'gray-row' : '';
    },
    updateShowStatus(row){
    console.log(row)
      let txt='隐藏'
      if(row.hide==1){
        txt='显示'
      }
      this.$Modal.confirm({
        content: '<p>确定要更改为<b>【'+txt+'】</b>状态吗？</p>',
        onOk: () => {
          this.http.post('/admin/figure/updateShowStatus',{id: row.id, hide: row.hide}).then(response=>{
            let data=response.data;
            if(data.code!==0){
              this.$Message.error(data.message);
            } else{
              this.getSpeakerList()
              this.$Message.success('已'+txt);
            }
          }).catch(e=>{
            console.log(e)
            this.$Message.error('网络错误');
          });
        }
      });
    }


  }

}
</script>
<style scoped>
/deep/ .ivu-table .gray-row td {
  background-color: #f0f0f0 !important;
}
</style>